import React, { MouseEvent } from "react";

import { Button, ButtonProps,Link } from "@catchoftheday/cg-components";

import { TemplateString } from "@common-vendors/generated/graphql";

const DEFAULT_MESSAGE = "Please click here for more information.";

type TemplatedMessageProp = {
  templateString: TemplateString;
  buttonProps?: ButtonProps;
  onClick?: (event: MouseEvent) => void;
};

export const TemplatedMessage = ({
  templateString,
  buttonProps,
  onClick,
}: TemplatedMessageProp) => {
  const { template, placeholders, default: defaultMessage } = templateString;

  if (!template || !placeholders) {
    return <>{defaultMessage}</>;
  }

  const re = /(\{\{.+?\}\})/;
  const splitStrings = template.split(re);
  const subComponentList: Array<JSX.Element | string> = [];

  splitStrings.forEach((splitString) => {
    if (!re.test(splitString)) {
      return subComponentList.push(splitString);
    }
    const matchId = splitString.replace(/\{\{(.+?)\}\}/, (_, p1) => p1.trim());
    const matchPlaceholder = placeholders.find(
      (placeholder) => placeholder?.id === matchId
    );
    if (onClick) {
      subComponentList.push(
        <Button
          onClick={onClick}
          key={matchId}
          variant="plain"
          sizeVariant="sm"
          p={0}
          color="secondary"
          textTransform="initial"
          fontSize="xs"
          fontWeight="normal"
          underlineOnHover
          {...(buttonProps || {})}
        >
          {matchPlaceholder?.text || DEFAULT_MESSAGE}
        </Button>
      );
    } else if (matchPlaceholder?.url) {
      subComponentList.push(
        <Link href={matchPlaceholder.url} key={matchId} target="_blank">
          {matchPlaceholder?.text || DEFAULT_MESSAGE}
        </Link>
      );
    } else if (matchPlaceholder?.text) {
      subComponentList.push(matchPlaceholder.text);
    }
  });

  return <>{subComponentList}</>;
};
